import React from "react";

export default function Footer() {
  return (
    <footer className="bg-[#0C377C] text-default text-center py-6 text-xs sm:text-base">
      © 2023 PT Surya Bintang Cemerlang | All rights reserved
    </footer>
  );
}
